import { render, staticRenderFns } from "./B-1-1-2_HomePage_BrandMessaging.vue?vue&type=template&id=44302a0a&"
import script from "./B-1-1-2_HomePage_BrandMessaging.vue?vue&type=script&lang=js&"
export * from "./B-1-1-2_HomePage_BrandMessaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports